export default __webpack_public_path__ + "static/media/rowe.117be227.png";